<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><a href="#/toc#toc-preface001"></a></h1>
<p class="noindent1">There had been <a id="page-1"></a>an underlying sweetness to Mike, I would say that was the essence of him. He had been gorgeous, athletic, bright, deeply good.</p>
<p class="noindent2">He was very confident about his mind.</p>
<p class="noindent2">He was so introverted in high school that I tried to compensate by being extroverted.</p>
<p class="noindent2">What struck me was his eyes. I couldn’t see the bottom, where they ended. They just kept going.</p>
<p class="noindent2">Mike was superb in the clutch. He probably won at least four games for us on the last shot.</p>
<p class="noindent2">He loved the Band, Dylan, Country Joe &amp; the Fish, the Dead.</p>
<p class="noindent2">He was not a warm and fuzzy person. I was a little intimidated by him.</p>
<p class="noindent2">It was hard for him to be just one of the group.</p>
<p class="noindent2">He was an inner cosmonaut. But he wasn’t the slightest bit off. He was one of the cool guys.</p>
<p class="noindent2">Mike was a sweet, vulnerable guy who was trying to find his place. There was an untethered quality. He was lost, good-hearted.</p>
<p class="noindent2">If I had to choose the five sanest people I knew at Duke, Mike would’ve been one.</p>
<p class="noindent2">Mike loved<a id="page-2"></a> to go exploring, to just pick a canyon and follow it to the end.</p>
<p class="noindent2">He was interested in truth, in the way the human mind worked.</p>
<p class="noindent2">Mike liked being outrageous. That was part of his charm.</p>
<p class="noindent2">He is the last person I would’ve expected to develop schizophrenia.</p>
<p class="noindent2">I wouldn’t agree that he’d be the last person to develop schizophrenia.</p>
<p class="noindent2">Mike is the most lonesome person I have ever known.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?25b8413b